import boxIcon from 'assets/icons/24px/components/box.svg';
import chartIcon from 'assets/icons/24px/components/chart.svg';
import imageIcon from 'assets/icons/24px/components/image.svg';
import linkIcon from 'assets/icons/24px/components/link.svg';
import listIcon from 'assets/icons/24px/components/list.svg';
import mapIcon from 'assets/icons/24px/components/map.svg';
import rowIcon from 'assets/icons/24px/components/row.svg';
import sectionIcon from 'assets/icons/24px/components/section.svg';
import spacerIcon from 'assets/icons/24px/components/spacer.svg';
import tableIcon from 'assets/icons/24px/components/table.svg';
import typographyIcon from 'assets/icons/24px/components/typography.svg';
import { PageComponentConfig } from 'types/builder/componentConfig';

type ComponentDisplay = {
    [k in PageComponentConfig['component']]?: {
        title: string;
        description?: string;
        icon: string;
    };
};

export const componentDisplayConfig: ComponentDisplay = {
    section: {
        title: 'Раздел',
        icon: sectionIcon,
        description:
            'Определяет раздел страницы и позволяет создать ссылку на раздел.',
    },
    box: {
        title: 'Блок',
        icon: boxIcon,
        description:
            'Базовый компонент, используемый для группировки нескольких компонентов. Дает возможность задать стиль фона в блоке.',
    },
    row: {
        title: 'Ряд',
        icon: rowIcon,
        description:
            'Располагает элементы внутри данного компонента в ряд, с возможностью поменять выравнивание и позиционирование элементов.',
    },
    typography: {
        title: 'Текст',
        icon: typographyIcon,
        description: 'Текстовый компонент (параграфы, заголовки)',
    },
    image: {
        title: 'Изображение',
        icon: imageIcon,
        description: 'Компонент, отображающий на странице изображения.',
    },
    list: {
        title: 'Список',
        icon: listIcon,
        description:
            'Компонент, создающий маркированный или нумерованный список.',
    },
    spacer: {
        icon: spacerIcon,
        title: 'Отступ',
        description:
            'Компонент, позволяющий задать отступ между другими компонентами.',
    },
    simpleLink: {
        title: 'Ссылка',
        icon: linkIcon,
        description:
            'Текстовый элемент, создающий гиперссылку на страницу, раздел или внешний ресурс.',
    },
    interactiveMap: {
        title: 'Карта',
        icon: mapIcon,
        description:
            'Компонент, создающий интерактивную карту с группировкой, маркерами и текстовыми подсказками',
    },
    table: {
        title: 'Таблица',
        icon: tableIcon,
        description: 'Редактируемая таблица',
    },
    interactiveChart: {
        title: 'График',
        icon: chartIcon,
        description: 'Компонент, создающий интерактивный график',
    },
};
